import { reportRoutes } from './routes';
import { useReportStudioStore } from './stores/report-studio-store';

export interface ModuleConfig {
  name: string;
  routes: typeof reportRoutes;
  stores: Record<string, unknown>;
  initialize?: () => void;
  cleanup?: () => void;
}

export const ReportsModule: ModuleConfig = {
  name: 'reports',
  routes: reportRoutes,
  stores: {
    reportStudio: useReportStudioStore,
  },
  initialize: () => {
    console.log('Reports module initialized');
  },
  cleanup: () => {
    // Clean up store state if needed
    useReportStudioStore.getState().reset();
    console.log('Reports module cleaned up');
  },
};

// Re-export types for convenience
export * from './types';

// Re-export hooks
export { useReportStudio } from './hooks/useReportStudio';

// Re-export components for use in other modules
export { default as ReportStudio } from './components/ReportStudio';
export { default as ReportParameterForm } from './components/ReportParameterForm';
export { default as ReportDataTable } from './components/ReportDataTable';

export default ReportsModule;
